
class Login extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.recoveryForm = this.element.querySelector("#customer__recover");
    this.loginForm = this.element.querySelector("#customer__login");
    this.registerFormElement = this.element.querySelector('#account__register-form');
    localStorage.removeItem('registration_in_progress');

    this.buttonBackground = this.element.querySelector('.customer__tab--background');
    if (window.location.href.indexOf("register") != -1) {
      this.firstButton = this.element.querySelector(".customer__tab");
    } else {
      this.firstButton = this.element.querySelector(".customer__tab:last-child");
    }

    if (window.location.href.indexOf("recover") != -1) {
      this.openRecover();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.openRecover.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-login"]',
      this.openLogin.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-login"]',
      this.submitLoginForm.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-forgot-pass"]',
      this.submitRecoveryForm.bind(this)
    );
    this.delegateElement.on(
      'click',
      '[data-action="slider-toggle"]',
      this.toggleSlider.bind(this)
    );

    if (this.registerFormElement) {
      this.registerFormElement.addEventListener('submit', function () {
        localStorage.setItem('registration_in_progress', 'true');
      });
    }
  }

  openRecover() {
    if (event) event.preventDefault();
    this.recoveryForm.setAttribute('aria-hidden', 'false');
    this.loginForm.setAttribute('aria-hidden', 'true');

  }
  openLogin() {
    event.preventDefault();
    this.recoveryForm.setAttribute('aria-hidden', 'true');
    this.loginForm.setAttribute('aria-hidden', 'false');

  }
  submitLoginForm(e) {
    if (e.key === "Enter") {
      event.preventDefault()
      this.element.querySelector("#customer__login-form")?.submit();
    };
  }
  submitRecoveryForm(e) {
    if (e.key === "Enter") {
      event.preventDefault()
      this.element.querySelector("#customer__recover-form")?.submit();
    };
  }
  toggleSlider(e) {
    const buttonBackgroundWidth = this.firstButton.offsetWidth;
    const width = e.target.offsetWidth;
    const id = e.target.dataset.id;

    if (window.location.href.indexOf("register") != -1) {
      if (id == 'login') {
        this.buttonBackground.style.transform = `translateX(calc(-${buttonBackgroundWidth}px - 1.5rem))`;
        this.buttonBackground.style.width = `${width}px`;
      } else {
        this.buttonBackground.style.transform = `translateX(0)`;
        this.buttonBackground.style.width = `${width}px`;
      }
    } else {
      if (id == 'recover') {
        this.buttonBackground.style.transform = `translateX(calc(${buttonBackgroundWidth}px + 1.5rem))`;
        this.buttonBackground.style.width = `${width}px`;
      } else {
        this.buttonBackground.style.transform = `translateX(0)`;
        this.buttonBackground.style.width = `${width}px`;
      }
    }

    const prevToggledButton = this.element.querySelector('.customer__tab[aria-expanded="true"]');
    prevToggledButton.setAttribute("aria-expanded", "false");
    e.target.setAttribute("aria-expanded", "true");
  }
}
customElements.define("customer-login", Login);

class AccountComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    if (window.location.pathname === '/account') {
      localStorage.removeItem('registration_in_progress');
    }

    new Popup(this.element);

    this.accountHeader = this.element.querySelector('.customerAccount--Header');

    this.stickyButton = this.element.querySelector('.customerAccount--StickyButton');
    if (this.element.querySelector('.customerAccount--NoAddress')) this.stickyButton.style.display = "none";

    this.element.querySelectorAll(".customerAccount--Country select").forEach(
      selector => new Shopify.CountryProvinceSelector(selector, null, {}, true)
    );

    this.selectElements = this.element.querySelectorAll(".customerAccount--Country select");
    this.setColor();

    this.bindEvents();
    this.handleRefreshState();
    this.currentBreakpoint = responsive.getCurrentBreakpoint()
    if (this.currentBreakpoint === 'phone') {
      this.element.querySelector(".customerAccount--MenuTab").setAttribute('aria-expanded', 'false');
    }
  }
  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-subtab"]', this.toggleSubTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-back"]', this.toggleBack.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="delete-address"]',
      this.deleteAddress.bind(this)
    );
    this.delegateElement.on('change', '[data-action="change-color"]', this.setColor.bind(this));
    responsive.addBreakpointListener("lap_and_up");
    this.delegateBody.on("breakpoint:lap_and_up", this.showMobileMenu.bind(this));
  }

  showMobileMenu(e) {
    const menuTab = this.element.querySelector('.customerAccount--Menu');

    if (!e.detail.matches) {
      this.accountHeader.style.display = "none";
      menuTab.style.display = "none";
      this.handleRefreshState();
    } else {
      this.accountHeader.style.display = "flex";
      menuTab.style.display = "flex";
    }
  }

  setColor() {
    this.selectElements.forEach(el => {
      if (el.selectedIndex === 0) {
        el.style.color = 'var(--primary_grey)';
      } else {
        el.style.color = 'var(--primary_text)';
      }
    });
  }

  handleRefreshState() {
    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.element.querySelector('#contactInfo').setAttribute('aria-visible', 'true');
    }
    // Get the URL search parameters
    var searchParams = new URLSearchParams(window.location.search);

    // Get the value of param1
    var param1Value = searchParams.get('location');

    this.showOrHide(param1Value);

    // Check if param1 has a value
    if (param1Value) {
      this.toggleTab(false, param1Value);
    }
  }

  deleteAddress(event) {
    event.preventDefault();
    const id = event.target.getAttribute("data-id");

    Shopify.postLink("/account/addresses/" + id, {
      parameters: { _method: "delete" },
    });
  }

  toggleBack() {
    const menuTab = this.element.querySelector('.customerAccount--Menu');
    menuTab.style.display = "flex";
    this.accountHeader.style.display = "block";
    this.stickyButton.style.display = "none";
    const allTabs = this.element.querySelectorAll('.customerAccount--MenuTab[aria-expanded="true"]');

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    const allContent = this.element.querySelectorAll('.customerAccount--Content');
    allContent.forEach((content) => {
      if (content.id == "activeOrders" || content.id == "orderHistory") return;
      content.setAttribute('aria-visible', 'false');
    });
  }

  showOrHide(id) {
    if (id === 'contactAddresses') {
      this.element.querySelector('.customerAccount--Header .customerAccount--OrderToggle').style.display = 'none';
      this.element.querySelector('.customerAccount--HeaderAddAddress').style.display = 'block';
      if (!responsive.matchesBreakpoint('lap_and_up') && !this.element.querySelector('.customerAccount--NoAddress')) this.stickyButton.style.display = 'block';
    } else if (id === 'contactOrders') {
      this.element.querySelector('.customerAccount--HeaderAddAddress').style.display = 'none';
      this.element.querySelector('.customerAccount--Header .customerAccount--OrderToggle').style.display = 'flex';
      if (!responsive.matchesBreakpoint('lap_and_up')) this.stickyButton.style.display = 'none';
    } else {
      this.element.querySelector('.customerAccount--HeaderAddAddress').style.display = 'none';
      this.element.querySelector('.customerAccount--Header .customerAccount--OrderToggle').style.display = 'none';
      if (!responsive.matchesBreakpoint('lap_and_up')) this.stickyButton.style.display = 'none';
    }
  }

  toggleTab(event, paramValue) {
    let id = paramValue;
    if (event) {
      id = event.target.dataset.id;
    }

    const allTabs = this.element.querySelectorAll('.customerAccount--MenuTab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.customerAccount--Content');
    const menuTab = this.element.querySelector('.customerAccount--Menu');


    if (responsive.matchesBreakpoint('pocket')) {
      this.accountHeader.style.display = "none";
      menuTab.style.display = "none";
    }


    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });
    if (event) {
      event.target.setAttribute('aria-expanded', 'true');
    } else {
      this.element.querySelector(`[data-id="${id}"]`).setAttribute('aria-expanded', 'true');
    }

    this.showOrHide(id);

    allContent.forEach((content) => {
      if (!content.classList.contains('customerAccount--ContentOrders')) {
        content.setAttribute('aria-visible', 'false');
      }

    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }

    // Get the current URL
    var currentUrl = window.location.href;

    // Create a new URL with updated search parameters
    var newUrl = currentUrl.split('?')[0] + `?location=${id}`;

    // Modify the URL without refreshing the page
    window.history.pushState({ path: newUrl }, '', newUrl);

  }


  toggleSubTab(event) {
    let target = event.target;
    if (!target.classList.contains('customerAccount--toggleTab')) {
      target = event.target.closest('.customerAccount--toggleTab');
    }
    console.log(target);
    const id = target.dataset.id;
    const allTabs = this.element.querySelectorAll('.customerAccount--toggleTab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.customerAccount--ContentOrders');



    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    target.setAttribute('aria-expanded', 'true');

    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }
  }
}


customElements.define("account-component-inner", AccountComponent);